import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as OtpActions from "../actionTypes/otpActionTypes";
import * as OtpActionCreators from "../actionCreators/otpActionCreators"
import { generateVerificationOtp, validateOtp } from "../services/APIservice";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";


function* generateOtp() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(OtpActionCreators.generateOtpRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(generateVerificationOtp);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(OtpActionCreators.generateOtpSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(OtpActionCreators.generateOtpFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(OtpActionCreators.generateOtpFailure(error))
    }
  }
}

function* verifyOtp({ request }: OtpActions.VerifyOtpAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(OtpActionCreators.verifyOtpRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(validateOtp, request);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(OtpActionCreators.verifyOtpSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(OtpActionCreators.verifyOtpFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(OtpActionCreators.verifyOtpFailure(error))
    }
  }
}

function* watchOnGenerateOtp() {
  yield takeEvery(OtpActions.GENERATE_OTP, generateOtp)
}
function* watchOnVerifyOtp() {
  yield takeEvery(OtpActions.VERIFY_OTP, verifyOtp)
}

export default function* OtpSaga() {
  yield all([
    fork(watchOnGenerateOtp),
    fork(watchOnVerifyOtp)
  ])
}